import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Spin } from "antd";
import { routes } from "../const";
import { baseUrl, isTask } from '../tasks';

export default function TaskCompletion() {
    const navigate = useNavigate();
    const { task } = useParams();
    const [ reward, setReward ] = useState("");
    const [ loading, setLoading ] = useState(true);

    useEffect(() => {
        isTask(task)
            .then(data => {
                if (data) {
                    window.localStorage.setItem(task, 1);
                    setReward(data.reward);
                    const clickdata = window.sessionStorage.getItem("log");
                    if (clickdata) {
                        window.sessionStorage.removeItem("log");
                        fetch(`${baseUrl}/api/clickdata/${task}`, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: clickdata
                        });
                    }
                } else {
                    navigate(routes.NOT_FOUND);
                }
                setLoading(false);
            });
        
    }, []);
    
    return (
        <div className="story flex flex-col justify-center items-center" style={{ backgroundImage: "url(/kueh-shop-transparent.jpg)"}}>

            <Spin className="mx" size="large" tip="Loading..." spinning={loading} >
            <div className=" bg-white m-4 p-6 flex flex-col items-center rounded-lg">
                <p className="text-3xl font-bold">Kueh Unlocked!</p>
                {!loading && <img src={reward} alt="kueh"/> }
                {/* <p className="text-justify text-xl">{tips[task]}</p> */}
            </div>
            </Spin>

            <Link to={ routes.TASK_SELECTION } className="m-4">
                <button className="bg-teal-800 hover:bg-teal-900 text-white font-bold py-4 px-14 rounded-full text-3xl">Help another customer</button>
            </Link>

            <Link to={ routes.POST_SURVEY } className="m-4">
                <button className="bg-slate-600 hover:bg-slate-700 text-white font-bold py-4 px-14 rounded-full text-3xl">End session</button>
            </Link>
            
        </div>
    )
}